/**
 * 项目工作空间（WorkspaceLayout）与全局 MainLayout 平级。
 * 与医项目列表 `/medproject/projects` 并列，详情段为 `:projectId`。
 */
export const WORKSPACE_ROUTE_BASE = '/medproject/projects';

/** 侧栏「返回」：医项目列表 */
export const WORKSPACE_PARENT_PATH = '/medproject/projects';
